import { loadCompositionEstimates } from "components/jiffy/products/product-composition-estimates";
import initJiffyMadeUpsellCard from "./jiffy-made-upsell-card/jiffy-made-upsell-card";

import "./product-details-upsell-section.scss";
import "./product-card-overrides.scss";

const $getUpsellSection = () => document.querySelector(".js-product-details-upsell-section");
const $getUpsellCards = () => {
  const $upsellSection = $getUpsellSection();
  return $upsellSection?.querySelectorAll(".js-product-card") || [];
};

const loadUpsellCompositionDeliveryDates = () => {
  const $cards = $getUpsellCards();
  const compositionIds = Array.from($cards).map($card => $card.dataset.compositionId);

  if (compositionIds.length) {
    loadCompositionEstimates(compositionIds);
  }
};

const init = () => {
  loadUpsellCompositionDeliveryDates();
  initJiffyMadeUpsellCard();
};

export default init;
